import {Component, Input, OnInit} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import { PermissionsService } from 'src/app/services/permissions/permissions.service';

@Component({
  selector: 'app-participation-help-modal',
  templateUrl: './participation-help-modal.component.pug',
  styleUrls: ['./participation-help-modal.component.scss'],
  standalone: false
})
export class ParticipationHelpModalComponent implements OnInit {
  @Input() request

  constructor(public _bsModalRef: BsModalRef, public permissionService: PermissionsService) {
  }


  ngOnInit(): void {

  }

  close() {
    this._bsModalRef.hide();
  }

}
